import { useRef } from 'react';

function useStable<T = unknown>(value: T) {
    const ref = useRef(value);
    ref.current = value;
    return ref;
}

export default useStable;
